import React, { useContext, useEffect, useState } from "react";
import {
  LightModeOutlined,
  DarkModeOutlined,
  Menu as MenuIcon,
  SettingsOutlined,
  ArrowDropDownOutlined,
} from "@mui/icons-material";
import FlexBetween from "./FlexBetween";
import {
  AppBar,
  Button,
  Box,
  Typography,
  IconButton,
  Toolbar,
  Menu,
  MenuItem,
  useTheme,
} from "@mui/material";
import { useCustomTheme } from "../../contexts/ThemeContext";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import EssentialComponent from "../Essential/EssentialComponent";
import getRequiredUserData from "../../utils/getBranchInfo";
import SuperAdminEditForm from "../User/editUserForm/superAdmin";
import { useSnackbar } from "../../contexts/InfoContext";
import { SpinnerContext } from "../../contexts/SpinnerContext";
import updateProfileImage from "../../api/users/profileImageChange";
import ProfileImageDialog from "../User/common/ProfileImageDialog";
const Navbar = ({
  currentUser,
  isSidebarOpen,
  setIsSidebarOpen,
  from = "other",
}) => {
  const theme = useTheme();

  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);
  const { toggleMode } = useCustomTheme();
  const { logout, user } = useAuth();
  const branchData = getRequiredUserData();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [userClaims, setUserClaims] = useState({});
  const [isButtonVisible, setIsButtonVisible] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const { openSnackbar } = useSnackbar();
  const { setIsSubmitting } = useContext(SpinnerContext);

  const toggleButton = () => {
    setIsButtonVisible(!isButtonVisible);
  };

  const handleProfileChange = () => {
    setIsDialogOpen(true);
  };

  const handleImageSave = async (formData) => {
    setIsSubmitting(true);
    try {
      formData.append("collectionName", "SuperAdmin");
      await updateProfileImage(user, user.uid, formData);
      openSnackbar("Profile image updated successfully.", "success");
      setIsDialogOpen(false);
    } catch (error) {
      if (error.response && error.response.data) {
        openSnackbar(
          error.response.data.message,
          error.response.data.type ? error.response.data.type : "error"
        );
      } else {
        openSnackbar(
          "An unexpected error occurred.Please kindly check your connection.",
          "error"
        );
      }
    }
    setIsSubmitting(false);
  };
  // Use useEffect to fetch idTokenResult when the component mounts
  useEffect(() => {
    async function fetchUserClaims() {
      try {
        const idTokenResult = await user.getIdTokenResult();
        setUserClaims(idTokenResult.claims);
      } catch (error) {}
    }
    fetchUserClaims();
  }, [user]);

  const navigate = useNavigate();
  const handleLogout = async () => {
    try {
      await logout();
      navigate("/login"); // Call your logout function from the useAuth context
    } catch (error) {}
  };

  const handleEdit = () => {
    setDialogOpen(true);
    handleClose();
  };

  const handleCardClick = (event) => {
    event.preventDefault();
    navigate(`/`);
  };
  const handleSetting = (event) => {
    event.preventDefault();
    navigate(`/setting`);
  };

  return (
    <>
      <ProfileImageDialog
        imageUrl={currentUser.profileImage}
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onSave={handleImageSave}
      />
      <AppBar
        sx={{
          position: "sticky",
          background: "none",
          boxShadow: "none",
          marginBottom: "40px",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          {/* LEFT SIDE */}
          <FlexBetween>
            {from !== "table" ? (
              <IconButton onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
                <MenuIcon />
              </IconButton>
            ) : (
              <Box display="flex" alignItems="center" gap="0.5rem">
                <div onClick={handleCardClick}>
                  <Typography
                    variant="h4"
                    fontWeight="bold"
                    color={theme.palette.secondary.main}
                    style={{ cursor: "pointer" }}
                  >
                    ASHAM LOLE
                  </Typography>
                </div>
              </Box>
            )}
            <FlexBetween
              backgroundColor={theme.palette.background.alt}
              borderRadius="9px"
              gap="3rem"
              p="0.1rem 1.5rem"
              style={{ marginLeft: "10px" }}
            >
              {branchData?.branchName && (
                <Typography
                  variant="h6"
                  style={{
                    fontSize: "18px",
                  }}
                >
                  {branchData?.branchName ? branchData?.branchName : ""}
                </Typography>
              )}
            </FlexBetween>
          </FlexBetween>

          {/* RIGHT SIDE */}
          <FlexBetween gap="1.5rem">
            <Button color="inherit" onClick={toggleButton}>
              Essentials
            </Button>
            <IconButton onClick={() => toggleMode()}>
              {theme.palette.mode === "dark" ? (
                <DarkModeOutlined sx={{ fontSize: "25px" }} />
              ) : (
                <LightModeOutlined sx={{ fontSize: "25px" }} />
              )}
            </IconButton>
            {userClaims.superAdmin ? (
              <IconButton onClick={handleSetting}>
                <SettingsOutlined sx={{ fontSize: "25px" }} />
              </IconButton>
            ) : (
              <div></div>
            )}

            <FlexBetween>
              <Button
                onClick={handleClick}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  textTransform: "none",
                  gap: "1rem",
                }}
              >
                <Box
                  component="img"
                  alt="profile"
                  onClick={userClaims.superAdmin && handleProfileChange}
                  src={
                    currentUser.profileImage
                      ? currentUser.profileImage
                      : "/assets/avator.jpg"
                  }
                  height="32px"
                  width="32px"
                  borderRadius="50%"
                  sx={{ objectFit: "cover" }}
                />
                <Box textAlign="left">
                  <Typography
                    fontWeight="bold"
                    fontSize="0.85rem"
                    sx={{ color: theme.palette.secondary[100] }}
                  >
                    {currentUser.fullName}
                  </Typography>
                </Box>
                <ArrowDropDownOutlined
                  sx={{ color: theme.palette.secondary[300], fontSize: "25px" }}
                />
              </Button>
              <Menu
                anchorEl={anchorEl}
                open={isOpen}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              >
                {userClaims.superAdmin && (
                  <MenuItem onClick={handleEdit}>Edit</MenuItem>
                )}
                <MenuItem onClick={handleLogout}>Log Out</MenuItem>
              </Menu>
            </FlexBetween>
          </FlexBetween>
        </Toolbar>
      </AppBar>

      {dialogOpen && (
        <SuperAdminEditForm
          admin={{ id: user.uid, ...currentUser }}
          isEditDialogOpen={dialogOpen}
          closeEditDialog={() => setDialogOpen(false)}
        />
      )}

      {isButtonVisible ? (
        <EssentialComponent isVisible={isButtonVisible} />
      ) : null}
    </>
  );
};

export default Navbar;
